module.exports = __webpack_public_path__ + "static/media/jetson_one_render_11.4ae7fecb.jpg";